module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/stretchlab-237c1425d11803f767157c4d264a6039.png";